// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    getAll: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding-credentials`,
};

const GetAll = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getAll}`, { params }).then(callback).catch(error).finally(next);
};

export const AdminBidCredentialsService = {
    GetAll,
};
